import { configureStore } from "@reduxjs/toolkit";
import aiChatsReducer from "./features/aiChats";
import analyticsReducer from "./features/analytics";
import attachmentsReducer from "./features/attachments";
import automationsReducer from "./features/automations";
import calendarReducer from "./features/calendar";
import campaignsReducer from "./features/campaigns";
import contactsReducer from "./features/contacts";
import conversationsReducer from "./features/conversations";
import emailTemplatesReducer from "./features/email-templates";
import merchantReducer from "./features/merchant";
import messagesReducer from "./features/messages";
import onboardingReducer from "./features/onboarding";
import paymentsReducer from "./features/payments";
import templatesReducer from "./features/templates";
import themeReducer from "./features/theme";

const store = configureStore({
  reducer: {
    aiChats: aiChatsReducer,
    attachments: attachmentsReducer,
    automations: automationsReducer,
    calendar: calendarReducer,
    campaigns: campaignsReducer,
    contacts: contactsReducer,
    conversations: conversationsReducer,
    emailTemplates: emailTemplatesReducer,
    merchant: merchantReducer,
    messages: messagesReducer,
    analytics: analyticsReducer,
    onboarding: onboardingReducer,
    payments: paymentsReducer,
    templates: templatesReducer,
    theme: themeReducer,
  },
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
